function monthByUTC(d = new Date()) {
  const m = d.getUTCMonth() // 0–11
  // Возвращаем название месяца на английском для использования в CSS переменных
  const monthNames = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december']
  return monthNames[m]
}

function applyMonthColor() {
  const root = document.documentElement
  const month = monthByUTC()
  const defaultVarName = `--blue-default-color-${month}`
  const defaultVal = getComputedStyle(root).getPropertyValue(defaultVarName).trim()

  const lightVarName = `--blue-light-color-${month}`
  const lightVal = getComputedStyle(root).getPropertyValue(lightVarName).trim()
  if (defaultVal && lightVal) {
    root.style.setProperty('--blue-default-color-season', defaultVal)
    root.style.setProperty('--blue-light-color-season', lightVal)
    return true
  }
  return false
}

export function applySeasonSettings() {
  // Попытка сразу
  if (applyMonthColor()) {
    return
  }

  // Подстраховка: подождём загрузки ресурсов (CSS) и пару кадров
  const deadline = Date.now() + 2000 // максимум ~2с «догоняем» стили

  function tick() {
    if (applyMonthColor()) {
      return
    }
    if (Date.now() > deadline) {
      return
    } // перестаём пытаться
    requestAnimationFrame(tick)
  }

  if (document.readyState === 'complete') {
    tick()
  } else {
    window.addEventListener('load', () => requestAnimationFrame(tick), { once: true })
    requestAnimationFrame(tick) // вдруг всё уже готово
  }
}
